const contacts = {
    eyebrow: 'יצירת קשר',
    title: 'נעים להכיר',
    description: 'תפקידים, שיתופי פעולה או סתם בעיה מעניינת — שלחו הודעה ואחזור אליכם.',
    email: 'אימייל',
    phone: 'טלפון',
    basedIn: 'מיקום',
};

export default contacts;
